// extracted by mini-css-extract-plugin
export default {"bottomNav":"BottomNav_bottomNav__buCJg","link":"BottomNav_link__5L5k7","linkActive":"BottomNav_linkActive__Ij5-X","icon":"BottomNav_icon__PsFqP","label":"BottomNav_label__ia8Uq"};